import { BusinessForm, ExtendedBusinessForm } from './types';

/**
 * Get the true legal form ("Micro" is not a real legal form).
 * "Micro" becomes "EI" in that case.
 */
export const getLegalForm = (
  businessForm: ExtendedBusinessForm,
): BusinessForm => (businessForm === 'Micro' ? 'EI' : businessForm);

/**
 * Check whether the business form is "Micro".
 */
export const isMicroCompany = (
  businessForm: ExtendedBusinessForm,
): businessForm is 'Micro' => businessForm === 'Micro';
